let nameRegExp = new RegExp("^[A-Za-z' ]{3,30}$");
let strongPassword = new RegExp(
  "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
);

function submitForm() {
  // e.preventDefault();
  let FirstName = $("#FirstName").val();
  if (FirstName == "" || !nameRegExp.test(FirstName)) {
    $("#FirstName").addClass("invalid"); // Add the "invalid" class
    return;
  } else {
    $("#FirstName").removeClass("invalid"); // Remove the "invalid" class
  }
  let password = $("#CreatePassword").val();
  if (!strongPassword.test(password) || password == "") {
    $("#CreatePassword").addClass("invalid");
    $("#CreatePasswordError").empty().append('Please provide strong password with 1 capital, 1 number and 1 special character');
    return;
  } else {
    $("#CreatePasswordError").empty();
    $("#CreatePassword").removeClass("invalid");
  }
  
  let formData = {
    shoppifyPassword: $("#CreatePassword").val(),
    email: $("#Email").val().toLowerCase(),
    fullName: $("#FirstName").val(),
    phoneNumber: $("#phone").val(),
  };

  var apiEndpoint ="https://api.yankeekicks.com/v1/userauth/user/shopify-registration";

  $.ajax({
    type: "POST",
    url: apiEndpoint,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: JSON.stringify(formData),
    success: function (data) {
      $("#register-customer-form form").submit(); // submit the form after API call is completed
      // handle API response here
    },
    error: function (jqXHR, textStatus, errorThrown) {
      $("#register-customer-form form").submit(); // submit the form after API call is completed
      console.error("API error:", textStatus, errorThrown);
      // handle API error here
    },
  });
}